/**
 * セキュリティ系ゲート（IpRestrictionGate / SamlEnforcementGate / MfaEnforcementGate）が
 * 強制中でも常にアクセスを許可する公開ルートの判定（#2982-2984）。
 * 3 ゲートで同一リストを共有する（個別コピーだと 1 箇所だけ公開パスを追加した際に
 * ゲート間でロック挙動が食い違うため、必ずここへ追加する）。
 * ※ MaintenanceGate は別リスト（/contact を含まない）のため対象外。
 */

// ログイン・認証系 + お問い合わせ
const PUBLIC_PATHS = ['/', '/action'];
const PUBLIC_PATH_PREFIXES = ['/auth/', '/contact'];

export const isSecurityGatePublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.includes(pathname) ||
  PUBLIC_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
